import { useBreadCrumbs } from "hooks/otros/useBreadCrumbs"
import type { BreadcrumbType } from "hooks/otros/useBreadCrumbs"
import { useSelectMenuItemSideBar } from "hooks/otros/useSelectMenuItemSideBar"

export function useLayout(breadcrumbs: BreadcrumbType[], openKeysSider: string[], selectKeySider: string) {
    useBreadCrumbs(breadcrumbs)
    useSelectMenuItemSideBar(openKeysSider, selectKeySider)
}